import { render, staticRenderFns } from "./ListDisposal.vue?vue&type=template&id=97307600&scoped=true&"
import script from "./ListDisposal.vue?vue&type=script&lang=js&"
export * from "./ListDisposal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97307600",
  null
  
)

export default component.exports